module.exports = __webpack_public_path__ + "img/winners-list_arzh.ad9347ac.png";